var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageScaleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6318 1.132C10.6318 0.681561 10.997 0.316406 11.4474 0.316406H16.341C16.7914 0.316406 17.1566 0.681561 17.1566 1.132V6.02558C17.1566 6.47602 16.7914 6.84117 16.341 6.84117C15.8906 6.84117 15.5254 6.47602 15.5254 6.02558V1.9476H11.4474C10.997 1.9476 10.6318 1.58244 10.6318 1.132Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66032 10.1055C2.11076 10.1055 2.47592 10.4706 2.47592 10.9211V14.999H6.5539C7.00434 14.999 7.36949 15.3642 7.36949 15.8146C7.36949 16.2651 7.00434 16.6302 6.5539 16.6302H1.66032C1.20988 16.6302 0.844727 16.2651 0.844727 15.8146V10.9211C0.844727 10.4706 1.20988 10.1055 1.66032 10.1055Z",
    fill: "#9A9A9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9176 0.555289C17.2362 0.873799 17.2362 1.39021 16.9176 1.70872L11.2085 7.41789C10.89 7.7364 10.3736 7.7364 10.055 7.41789C9.73653 7.09938 9.73653 6.58297 10.055 6.26446L15.7642 0.555289C16.0827 0.236779 16.5991 0.236779 16.9176 0.555289Z",
    fill: "#9A9A9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94621 9.52795C8.26472 9.84645 8.26472 10.3629 7.94621 10.6814L2.23704 16.3905C1.91853 16.7091 1.40212 16.7091 1.08361 16.3905C0.765099 16.072 0.765099 15.5556 1.08361 15.2371L6.79278 9.52795C7.11129 9.20943 7.6277 9.20943 7.94621 9.52795Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageScaleIcon);
export default __webpack_public_path__ + "static/media/image_scale_icon.b894527ce11adc3ee6ed4b87526be3ee.svg";
export { ForwardRef as ReactComponent };